import { useBaseApiQuery } from "@query/baseQuery";


export const useShopItemListQuery = ({ page, clubUuid, name, siteUuid, availibilityFilter }) => {
    const params = { 
        site_uuid: siteUuid ? siteUuid : null,
        name,
        availibility_filter: availibilityFilter
    };

    return useBaseApiQuery(
        {
            endpoint: `/club/${clubUuid}/shopItem/page/${page}`,
            params: params
        },
        {
            enabled: !!clubUuid && !!availibilityFilter,
            queryKey: [
                "shopItemList",
                clubUuid,
                page,
                params.site_uuid,
                name,
                availibilityFilter
            ]
        }
    );
};


export const useShopItemQuery = (shopItemUuid)=>{
        return useBaseApiQuery(
        {
            endpoint: `/shopItem/${shopItemUuid}`
        },
                {
            enabled: !!shopItemUuid,
            queryKey: [
                "shopItemDetail",
                shopItemUuid
            ]
        }
    )
}


export const useSiteShopItemsQuery = (clubUuid, shopItemUuid) => {
    return useBaseApiQuery(
        {
            endpoint: `/club/${clubUuid}/shopItem/${shopItemUuid}/siteShopItems`
        },
        {
            enabled: !!clubUuid && !!shopItemUuid,
            queryKey: [
                "siteShopItems",
                clubUuid,
                shopItemUuid
            ]
        }
    );
};